export default "__VITE_ASSET__CVzoXYEb__"